<template>
<div>
    <bar-manut 
        single-entity="Estado" 
        plural-entity="Estados" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
    <div class="default-container">
        <div>
            <div class="row">
                <form-field v-model="estado.uf" :metadata="metadata.estado.uf" type="text" col="2" 
                    :disabled="editing" name="uf" :v-errors="errors" v-validate="metadata.estado.uf.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.nomeuf" type="text" col="6" :metadata="metadata.estado.nomeuf" 
                    name="nomeuf" :v-errors="errors" v-validate="metadata.estado.nomeuf.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.codibge" type="number" col="2" :metadata="metadata.estado.codibge"
                    name="codibge" :v-errors="errors" v-validate="metadata.estado.codibge.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.aicminterno" type="value" col="2" :metadata="metadata.estado.aicminterno" :precision="2"
                    name="aicminterno" :v-errors="errors" v-validate="metadata.estado.aicminterno.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.aicminter" type="value" col="2" :metadata="metadata.estado.aicminter" :precision="2"
                    name="aicminter" :v-errors="errors" v-validate="metadata.estado.aicminter.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.mva" type="value" col="2" :metadata="metadata.estado.mva" :precision="2"
                    name="mva" :v-errors="errors" v-validate="metadata.estado.mva.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="estado.ricm" type="value" col="2" :metadata="metadata.estado.ricm" :precision="2"
                    name="ricm" :v-errors="errors" v-validate="metadata.estado.ricm.validator"></form-field>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            estado: {...this.$store.getters.getEntities.estado},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadEstado', { id: this.index } )
            if (this.$store.getters.getEstado) {
                this.estado = {...this.$store.getters.getEstado}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/estado/' + this.estado.uf

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/estado/'
            var sendData = {}

            sendData = { estado: this.estado }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/estado-form.vue